var map = {
	"./screenShots_astramed-1.jpg": 101,
	"./screenShots_astramed-2.jpg": 102,
	"./screenShots_astramed-3.jpg": 103,
	"./screenShots_blash-1.jpg": 104,
	"./screenShots_blash-2.jpg": 105,
	"./screenShots_blash-3.jpg": 106,
	"./screenShots_delivery-1.jpg": 107,
	"./screenShots_delivery-2.jpg": 108,
	"./screenShots_delivery-3.jpg": 109,
	"./screenShots_fund-1.jpg": 110,
	"./screenShots_fund-2.jpg": 111,
	"./screenShots_fund-3.jpg": 112,
	"./screenShots_jewelry-1.jpg": 113,
	"./screenShots_jewelry-2.jpg": 114,
	"./screenShots_jewelry-3.jpg": 115,
	"./screenShots_new-year-1.jpg": 116,
	"./screenShots_new-year-2.jpg": 117,
	"./screenShots_new-year-3.jpg": 118,
	"./screenShots_poland-1.jpg": 119,
	"./screenShots_poland-2.jpg": 120,
	"./screenShots_poland-3.jpg": 121,
	"./screenShots_web-1.jpg": 122,
	"./screenShots_web-2.jpg": 123,
	"./screenShots_web-3.jpg": 124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;